import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as externalPersonnel from '../../../../external-personnel'
import * as subaward from '../subaward'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: subaward.RESOURCE.payload.dimension.partialId,
      partialId: subaward.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'PI at the subrecipient institution who is responsible for this subaward',
    isOptional: true,
    name: 'Subrecipient PI',
    partialId: PartialId.Standard.create('subrecip_pi'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        externalPersonnel.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
